import React from 'react';

const VeteranInformationDescription = (
  <>
    <p>Next, we’ll ask you a few more questions about the Veteran.</p>
    <p>
      We’ll use the Veteran’s mailing address and contact information to process
      this application.
    </p>
  </>
);

export default VeteranInformationDescription;
